import PropTypes from 'prop-types';
import React from 'react';
import AnnotationField from './AnnotationField';

class SkosLabels extends React.Component {

    render() {

        const { schemeIRI, onRemoveLabel, isReadOnly, onUpdate, canDeleteIfDefault, draggable, xlLabelType, ariaLabel,
            existingValues, name, labels, entailed, defaultLang, projectIRI, id } = this.props;

        if (!labels) return null;

        return (
            Object.keys(labels).sort().map((lang) => {
                const labelItems = Array.isArray(labels[lang]) ? labels[lang] : [labels[lang]];
                let positions = {};
                labelItems.forEach((label, i) => positions[label] = i);
                return <div key={lang}>
                    {
                        labelItems
                            .filter(label => !entailed || !entailed[name] || !entailed[name][lang] || !entailed[name][lang].includes(label))
                            .filter(label => {
                                // We handle a very edge case where an XL label exists with same value as a label
                                const labelCount = labels[lang] && Array.isArray(labels[lang]) ?
                                    labels[lang].filter(innerLabel => innerLabel === label).length
                                    :
                                    0;
                                return labelCount < 2;
                            })
                            .sort((a, b) => {
                                if (a.toLowerCase() < b.toLowerCase()) return -1;
                                if (a.toLowerCase() > b.toLowerCase()) return 1;
                                return 0;
                            })
                            .map((label, index) =>
                                <AnnotationField
                                    draggable={draggable}
                                    dataTest={name + "-" + lang + "-" + index}
                                    key={lang + "-" + label}
                                    checkValues={true}
                                    ariaLabel={ariaLabel + " with language " + lang + ", item " + index}
                                    existingValues={existingValues[lang]}
                                    schemeIRI={schemeIRI}
                                    conceptIRI={id}
                                    xlLabelType={xlLabelType}
                                    projectIRI={projectIRI}
                                    canDeleteIfDefault={canDeleteIfDefault || (Array.isArray(labels[defaultLang]) && labels[defaultLang].length > 1)}
                                    onUpdate={onUpdate(name, lang, Array.isArray(labels[lang]) ? positions[label] : null)}
                                    defaultLang={defaultLang}
                                    isReadOnly={isReadOnly}
                                    onDelete={() => onRemoveLabel(name, lang, label)}
                                    property={name}
                                    text={label}
                                    lang={lang} />
                            )
                    }
                </div>;
            })
        );
    }
}

SkosLabels.defaultProps = {
    isReadOnly: false,
    draggable: false,
    canDeleteIfDefault: true
};

SkosLabels.propTypes = {
    id: PropTypes.string.isRequired,
    draggable: PropTypes.bool,
    labels: PropTypes.object,
    ariaLabel: PropTypes.string,
    entailed: PropTypes.object,
    schemeIRI: PropTypes.string,
    defaultLang: PropTypes.string,
    isReadOnly: PropTypes.bool,
    projectIRI: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onRemoveLabel: PropTypes.func.isRequired,
    canDeleteIfDefault: PropTypes.bool,
    name: PropTypes.string.isRequired,
    xlLabelType: PropTypes.string,
    existingValues: PropTypes.object.isRequired
};

export default SkosLabels;